/**
 * Total Highcharts height for full-screen mode: fills flex space above the HTML legend.
 * Navigator/range selector live inside this height — do not subtract extra "chrome".
 * @param {number} bodyHeight
 * @param {number} legendHeight
 */
export function computeFullscreenStockChartHeight(bodyHeight, legendHeight) {
  const safeBody = Number.isFinite(bodyHeight) ? bodyHeight : 0;
  const safeLegend = Number.isFinite(legendHeight) ? legendHeight : 0;
  return Math.max(200, Math.floor(safeBody - safeLegend - 4));
}
